import { Tooltip } from '@lib/components'
import { Badge } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { useTrialBadge } from './useTrialBadge'

export const TrialBadge: React.FC = () => {
  const handleOnClick = useTrialBadge()

  return (
    <Tooltip
      content={
        <div>
          Unsaved project. Please
          <br /> save to profile.
        </div>
      }
      position="bottom"
      onClick={handleOnClick}
    >
      <Badge type="trial_14" size="large" />
    </Tooltip>
  )
}
